module.exports = "/remote-dist/ab2cc646e576a9387c1c69a506919a25.png";